'use strict'

import ApiClient from './ApiClient'

export default class ManageBcardRepository {
  // TODO 共通化
  setMgmtParam (isMgmt, params) {
    params = params || {}

    if (isMgmt) {
      params.is_mgmt = '1' // TODO this.app_flag.ON
    }

    return params
  }

  /**
   * 自分の名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchBox (data) {
    // クエリで指定するデータを移動する
    const params = this.setMgmtParam(true, {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    })

    data = {
      search_target: 'my',
      free_word: data.free_word || '',
      name: data.name || '',
      corporate_name: data.corporate_name || '',
      dept_post: data.dept_post || '',
      zipcode: data.zipcode || '',
      address: data.address || '',
      tel: data.tel || '',
      fax: data.fax || '',
      mail: data.mail || '',
      memo: data.memo || '',
      keywords: data.keywords || '',
      openflag: data.openflag || [],
      tags: data.tags || [],
      exchange_date_from: data.exchange_date_from || '',
      exchange_date_to: data.exchange_date_to || '',
      ex_location: data.ex_location || '',
      ex_trigger: data.ex_trigger || '',
      in_introducer: data.in_introducer || [],
      out_introducer: data.out_introducer || [],
      age: data.age || '',
      display_mode: data.display_mode || ''
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * すべての名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchAll (data) {
    // クエリで指定するデータを移動する
    const params = this.setMgmtParam(true, {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    })

    data = {
      search_target: 'all',
      free_word: data.free_word || '',
      name: data.name || '',
      corporate_name: data.corporate_name || '',
      dept_post: data.dept_post || '',
      zipcode: data.zipcode || '',
      address: data.address || '',
      tel: data.tel || '',
      fax: data.fax || '',
      mail: data.mail || '',
      memo: data.memo || '',
      keywords: data.keywords || '',
      openflag: data.openflag || [],
      tags: data.tags || [],
      exchange_date_from: data.exchange_date_from || '',
      exchange_date_to: data.exchange_date_to || '',
      exchangers: data.exchangers || [],
      ghost_exchangers: data.ghost_exchangers || '',
      ex_location: data.ex_location || '',
      ex_trigger: data.ex_trigger || '',
      in_introducer: data.in_introducer || [],
      out_introducer: data.out_introducer || [],
      age: data.age || '',
      display_mode: data.display_mode || ''
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * お気に入り名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchFav (data) {
    // クエリで指定するデータを移動する
    const params = this.setMgmtParam(true, {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    })

    data = {
      search_target: 'fav',
      free_word: data.free_word || '',
      name: data.name || '',
      corporate_name: data.corporate_name || '',
      dept_post: data.dept_post || '',
      zipcode: data.zipcode || '',
      address: data.address || '',
      tel: data.tel || '',
      fax: data.fax || '',
      mail: data.mail || '',
      memo: data.memo || '',
      keywords: data.keywords || '',
      openflag: data.openflag || [],
      tags: data.tags || [],
      exchange_date_from: data.exchange_date_from || '',
      exchange_date_to: data.exchange_date_to || '',
      ex_location: data.ex_location || '',
      ex_trigger: data.ex_trigger || '',
      in_introducer: data.in_introducer || [],
      out_introducer: data.out_introducer || [],
      age: data.age || '',
      display_mode: '0' // 最新固定
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * 最近見た名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchAcc (data) {
    // クエリで指定するデータを移動する
    const params = this.setMgmtParam(true, {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    })

    data = {
      search_target: 'acc'
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * 画像未登録名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchNoimage (data) {
    // クエリで指定するデータを移動する
    const params = this.setMgmtParam(true, {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    })

    data = {
      search_target: 'noimage',
      search_target_noimage: data.search_target_noimage || '',
      exchange_date_from: data.exchange_date_from || '',
      exchange_date_to: data.exchange_date_to || ''
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * 名寄せ候補名刺検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchNonjudged (data) {
    // クエリで指定するデータを移動する
    const params = this.setMgmtParam(true, {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    })

    data = {
      search_target: 'nonjudged'
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * 名刺履歴検索
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  searchHistory (data) {
    // クエリで指定するデータを移動する
    const params = this.setMgmtParam(true, {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    })

    data = {
      search_target: 'all',
      display_mode: '1',
      sid_person: data.sid_person
    }

    return ApiClient().post(`/bcards`, data, { params })
  }

  /**
   * 複数の名刺IDを指定して、関連する名刺または名刺人物情報を一括で削除します。
   * @param {object} params
   * @returns {*}
   */
  bulkDelete (params) {
    return ApiClient().post(`/mgmt/bcards/delete`, params)
  }

  /**
   * CSVファイルからの登録状況一覧を取得
   * @param {object} params
   * @param {bool} params.isMgmt
   * @returns {*}
   */
  getBcardCsvs (params) {
    params = this.setMgmtParam(true, params)

    // TODO [次期] POST /mgmt/bcard-csvs に変更する
    return ApiClient().get(`/bcard-csvs`, { params })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/ManageBcardRepository.js